var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.29 9.53",
    style: {
      enableBackground: "new 0 0 8.29 9.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.29,3.95V2.28C6.12,2.19,6.04,0.21,6.04,0.02V0H4.35v6.5l0,0c0,0.74-0.59,1.33-1.33,1.33 c-0.74,0-1.33-0.6-1.33-1.34c0-0.74,0.6-1.33,1.34-1.33c0.13,0,0.26,0.02,0.39,0.06V3.51C1.76,3.29,0.24,4.46,0.03,6.11 C-0.19,7.77,0.98,9.29,2.63,9.5c1.66,0.22,3.17-0.95,3.39-2.61c0.02-0.18,0.02-0.34,0.02-0.52v-3.2C6.82,3.89,8.29,3.95,8.29,3.95z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.b06251bda74763cda3db15a2b5fcff5b.svg";
export { ForwardRef as ReactComponent };